import { memoize } from "lodash";
import { observable, runInAction } from "mobx";

import { apiCallGetDebugAIData } from "../../../api/developer-api/api-call-get-debug-ai-data";

import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import { TEt3PickerSingleValue } from "../../../TypesNEW";
import {
  TDebugAIImageCheckerData,
  TDebugAIImageCompareData
} from "../../../Types";

class DebugAIStore {
  imageCheckerData = observable.box<TDebugAIImageCheckerData>([]);
  imageCompareData = observable.box<TDebugAIImageCompareData>([]);

  limit = observable.box<TEt3PickerSingleValue>({
    label: "10",
    value: "10"
  });
  type = observable.box<TEt3PickerSingleValue>({
    label: "IMAGE_COMPARE",
    value: "IMAGE_COMPARE"
  });
  setLimit = (limit: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.limit.set(limit);
    });
  };

  setType = (type: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.type.set(type);
    });
  };
  getImageCheckerDataFromDatabase = async () => {
    getCoreUIStore().setIsLoading("DEVELOPER_DEBUG_IMAGE_AI", true);
    const { status, data, code } = await apiCallGetDebugAIData(
      parseInt(this.limit.get().value)
    );
    getCoreUIStore().setIsLoading("DEVELOPER_DEBUG_IMAGE_AI", false);
    if (status === "OK") {
      this.imageCheckerData.set(data.imageCheckerData);
      this.imageCompareData.set(data.imageCompareData);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}
const getDebugAIData = memoize(
  () => new DebugAIStore(),
  () => 1
);
export default getDebugAIData;
